/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import { socialGetSocialBilibiliVideoinfo } from "../../funcs/socialGetSocialBilibiliVideoinfo.js";
import { GetSocialBilibiliVideoinfoRequest$zodSchema } from "../../models/getsocialbilibilivideoinfoop.js";
import { formatResult, ToolDefinition } from "../tools.js";

const args = {
  request: GetSocialBilibiliVideoinfoRequest$zodSchema.optional(),
};

export const tool$socialGetSocialBilibiliVideoinfo: ToolDefinition<
  typeof args
> = {
  name: "social-get-social-bilibili-videoinfo",
  description: `查询 B站视频

想在你的应用里展示B站视频的详细信息吗？无论是封面、标题，还是播放量、UP主信息，这个接口都能一网打尽。

## 功能概述
通过提供视频的 \`aid\` 或 \`bvid\`，你可以获取到该视频的完整元数据，包括多P信息、UP主资料、数据统计等。

## 响应体字段说明
- **\`copyright\` (视频类型)**: \`1\` 代表原创，\`2\` 代表转载。
- **\`owner\` (UP主信息)**: 包含 \`mid\`, \`name\`, \`face\` 等UP主的基本资料。
- **\`stat\` (数据统计)**: 包含了播放、弹幕、评论、点赞、投币、收藏、分享等核心数据。
- **\`pages\` (分P列表)**: 这是一个数组，包含了视频的每一个分P的信息，即使是单P视频也会有一个元素。`,
  scopes: ["read"],
  annotations: {
    "title": "",
    "destructiveHint": false,
    "idempotentHint": false,
    "openWorldHint": true,
    "readOnlyHint": true,
  },
  args,
  tool: async (client, args, ctx) => {
    const [result] = await socialGetSocialBilibiliVideoinfo(
      client,
      args.request,
      { fetchOptions: { signal: ctx.signal } },
    ).$inspect();

    if (!result.ok) {
      return {
        content: [{ type: "text", text: result.error.message }],
        isError: true,
      };
    }

    return formatResult(result.value);
  },
};
